<template>
  <div class="info-dialog" v-if="dialogVisible">
    <div class="popup-box-wrapper">
      <div class="popup-close" @click="hideDialog">
        <img src="@/assets/image/icons/icon-close-circle.png">
      </div>
      <div class="popup-box">
        <div class="header">
          <div class="title">{{ $t('title') }}</div>
          <div class="subtitle">{{ $t('') }}</div>
        </div>
        <div class="info-form">
          <div class="form-group">
            <div class="form-label">{{ $t('fullName') }}</div>
            <md-input-item
              class="underline"
              ref="fullName"
              name="fullName"
              title=""
              v-model="form.fullName"
              v-validate="'required'"
              :error="errors.first('fullName')"
            ></md-input-item>
          </div>
          <div class="form-group">
            <div class="form-label">{{ $t('address') }}</div>
            <md-input-item
              class="underline"
              ref="address"
              name="address"
              title=""
              v-model="form.address"
              v-validate="'required'"
              :error="errors.first('address')"
            ></md-input-item>
          </div>
          <div class="form-group">
            <div class="form-label" style="min-width: 86px">{{ $t('phoneNumber') }}</div>
            <md-input-item
              class="underline"
              ref="mobile"
              name="mobile"
              type="digit"
              title=""
              v-model="form.mobile"
              v-validate="'required'"
              :error="errors.first('mobile')"
            ></md-input-item>
          </div>
        </div>
        <div class="btn-submit">
          <md-button
            type="green-dark"
            round
            @click="submitForm"
          >
            {{ $t('submit') }}
          </md-button>
        </div>
        <div class="tip">
          {{ $t('tip') }} <span style="font-weight: bold">pendanaan@kreditpintar.com</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Popup, Button, InputItem } from 'mand-mobile'
import dialogMixins from '@/mixins/dialog'

export default {
  i18n: {
    messages: {
      en: {
        title: 'Pastikan nomor telepon dan alamat Anda benar',
        fullName: 'Nama Lengkap:',
        address: 'Alamat:',
        phoneNumber: 'Nomor Telepon:',
        submit: 'Simpan',
        tip: '*Hadiah akan diberikan setelah acara berakhir, jika ada pertanyaan silahkan hubungi ',
      },
      id: {
        title: 'Pastikan nomor telepon dan alamat Anda benar',
        fullName: 'Nama Lengkap:',
        address: 'Alamat:',
        phoneNumber: 'Nomor Telepon:',
        submit: 'Simpan',
        tip: '*Hadiah akan diberikan setelah acara berakhir, jika ada pertanyaan silahkan hubungi ',
      },
    },
  },
  components: {
    [Popup.name]: Popup,
    [Button.name]: Button,
    [InputItem.name]: InputItem,
  },
  props: {
    reward: {
      type: Number,
      default: 0,
    },
  },
  mixins: [dialogMixins],
  data() {
    return {
      form: {
        fullName: '',
        address: '',
        mobile: '',
      },
      loading: false,
    }
  },
  methods: {
    async submitForm() {
      const valid = await this.$validator.validate()
      if (!valid) return
      this.$emit('updateContactInfo', this.form)
      this.hideDialog()
    },
  },
}
</script>

<style scoped lang="stylus">
.info-dialog
  z-index: 9999999;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, .8);
  .popup-box-wrapper
    position: absolute;
    width: 88%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  .popup-close
    text-align: right;
    img
      width: 25px;
      height: 25px;
      margin-bottom: 10px;
  .popup-box
    padding: 30px 20px 24px;
    border-radius: 6px;
    background-color: #fff;
    max-height: 70vh;
    overflow-y: scroll;
  .header
    text-align center
    line-height 21px
    margin-bottom 20px
    .title
      font-size 17px
      font-weight bold

.form-group
  display flex
  justify-content flex-start
  align-items center
  margin-bottom 10px
  .form-label
    margin-right 2px
    font-size 14px
    color #2C2E38
    @media (max-width 320px ) {
      font-size 12px
    }
  .md-input-item
    flex-grow 2

.btn-submit
  padding 20px 10px 16px
  .md-button
    background-color #077247
    color #fff

.tip
  font-size 10px
</style>
